export default "__VITE_ASSET__BUsS7IdW__"